import RelaxFEIMController from "../server/RelaxFEIMController";
import IRelaxFeimCommands from "./IRelaxFeimCommands";

 class FeimCommands implements IRelaxFeimCommands {
    initializeAPI() {
        RelaxFEIMController.initializeAPI();
    }

    configure(data:any) {
        RelaxFEIMController.configure(data);
    }

    gameLoadStarted() {
        RelaxFEIMController.gameLoadStarted();
    }

    gameLoadProgress(progress: number) {
        RelaxFEIMController.gameLoadProgress(progress);
    }

    gameLoadCompleted() {
        RelaxFEIMController.gameLoadCompleted();
    }

    balanceUpdate(balance: number) {
        RelaxFEIMController.balanceUpdate(balance);
    }

    autoPlayStarted() {
        RelaxFEIMController.autoPlayStarted();
    }

    autoPlayFinished() {
        RelaxFEIMController.autoPlayFinished();
    }

    winUpdate(winValue: number) {
        RelaxFEIMController.winUpdate(winValue);
    }

    betUpdate(bet: number) {
        RelaxFEIMController.betUpdate(bet);
    }

    dreamDropEnded() {
        RelaxFEIMController.dreamDropEnded();
    }

    gameRoundStarted(balance: any) {
        RelaxFEIMController.gameRoundStarted(balance);
    }

    gameRoundEnded(balance: any) {
        RelaxFEIMController.gameRoundEnded(balance);
    }

    sendUserAction(actionUrl: string, inNewWindow: boolean = false) {
        RelaxFEIMController.sendUserAction(actionUrl, inNewWindow);
    }

    showHistory() {
        RelaxFEIMController.showHistory();
    }

    fastPlayActivated(value: boolean) {
        RelaxFEIMController.fastPlayActivated(value);
    }

    featureStarted() {
        RelaxFEIMController.featureStarted();
    }

    featureFinished() {
        RelaxFEIMController.featureFinished()
    }
}

export default new FeimCommands
